<script setup lang="ts">

import { ref, watch } from 'vue';
import { useRouter } from "@library/Services";

const router = useRouter();
const pageTitle = ref('');
const pageIndex = ref( 2 );

watch( () => router.current.value, route =>
{
    pageTitle.value = String( route.meta?.title );
    if( route.fullPath.indexOf( '/timeline' ) == 0 ) pageIndex.value = 0;
    else if( route.fullPath.indexOf( '/trips' ) == 0 ) pageIndex.value = 1;
    else if( route.fullPath.indexOf( '/my-garage' ) == 0 ) pageIndex.value = 2;
    else if( route.fullPath.indexOf( '/my-marketplace' ) == 0 ) pageIndex.value = 3;
    else if( route.fullPath.indexOf( '/safety' ) == 0 ) pageIndex.value = 4;
    else pageIndex.value = -1;
}, { immediate: true } );

</script>

<template>

    <div class="bg-gray-50 dark:bg-gray-900 z-50 w-full">
        <div class="overflow-hidden -mt-4 items-center flex flex-col w-full h-[85px] -top-[10px]">
            <div class="grid grid-cols-5 absolute w-full h-[78px] left-0 top-3">
                <RouterLink :to="'/'" class="h-full flex justify-center">
                    <img v-if="pageIndex != 0" src="@/assets/images/phone/timeline.png" class="h-full" />
                    <img v-if="pageIndex == 0" src="@/assets/images/phone/timeline-selected.png" class="h-full absolute top-0" />
                </RouterLink>
                <RouterLink :to="'/'" class="h-full flex justify-center">
                    <img v-if="pageIndex != 1" src="@/assets/images/phone/trips.png" class="h-full" />
                    <img v-if="pageIndex == 1" src="@/assets/images/phone/trips-selected.png" class="h-full absolute top-0" />
                </RouterLink>
                <RouterLink :to="'/my-garage'" class="h-full flex justify-center">
                    <div class="bg-gray-50 dark:bg-gray-900 rounded-full w-[78px] h-[78px] absolute"></div>
                    <img v-if="pageIndex != 2" src="@/assets/images/phone/my-garage.png" class="h-full" />
                    <img v-if="pageIndex == 2" src="@/assets/images/phone/my-garage-selected.png" class="h-full absolute top-0" />
                </RouterLink>
                <RouterLink :to="'/my-marketplace'" class="h-full flex justify-center">
                    <img v-if="pageIndex != 3" src="@/assets/images/phone/marketplace.png" class="h-full" />
                    <img v-if="pageIndex == 3" src="@/assets/images/phone/marketplace-selected.png" class="h-full absolute top-0" />
                </RouterLink>
                <RouterLink :to="'/safety'" class="h-full flex justify-center">
                    <img v-if="pageIndex != 4" src="@/assets/images/phone/safety.png" class="h-full" />
                    <img v-if="pageIndex == 4" src="@/assets/images/phone/safety-selected.png" class="h-full absolute top-0" />
                </RouterLink>
            </div>
        </div>
    </div>    

</template>